import { Container, Flex, Heading, Spinner, Text, TextField } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import TransactionService from "../../core/services/TransactionService";
import React, { useEffect, useMemo, useState } from "react";
import {AxisOptions, Chart} from 'react-charts'
import moment from "moment";
import { IFinStatsForUser } from "../../core/types/services-types/transaction-types";
import Decimal from 'decimal.js';


export interface ChartPoint {
  primary: string;
  secondary: number;
}

// одна серия
export interface ChartSeries {
  label: string;
  data: ChartPoint[];
}


export default function FinAnalitycsPage() {
    const SCALE = new Decimal('1000000')
    const [fromDate, setFromDate] = useState<string>(moment().subtract(30, 'days').format('YYYY-MM-DD'))
    const [toDate, setToDate] = useState<string>(moment().format('YYYY-MM-DD'))
    const [dataFromServer, setDataFromServer] = useState<IFinStatsForUser[]>([])
    const [fetchAnalitycs, isLoading, error, errors] = useFetch(async () => {
        const data = await TransactionService.GetStatsForUser(fromDate, toDate)
        console.log(data)
        setDataFromServer(data)
    })

    const dataToChartsStructure = useMemo(() => {
        return [
    {
      label: 'Приход',
      data: dataFromServer.map(row => ({
        primary: row.day,
        secondary: new Decimal(row.income).div(SCALE).toNumber()
      }))
    },
    {
      label: 'Уход',
      data: dataFromServer.map(row => ({
        primary: row.day,
        secondary: new Decimal(row.outcome).div(SCALE).toNumber()
      }))
    }
  ];
    }, [dataFromServer])
   const primaryAxis = useMemo<AxisOptions<ChartPoint>>(
    () => ({
      getValue: datum => datum.primary,
      scaleType: 'band'
    }),
    []
  );

  const secondaryAxes = useMemo<AxisOptions<ChartPoint>[]>(
    () => [
      {
        getValue: datum => datum.secondary,
        scaleType: 'linear',
        min: 0
      }
    ],
    []
  );
    useEffect(() => {
        fetchAnalitycs()
    }, [fromDate, toDate])
    return (
        <Container className="md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-20"> 
            <Heading size={'7'} weight={'bold'}>
                Финансовая аналитика
            </Heading>
            <hr />
             <Text>Укажите даты, за которые хотите видеть статистику</Text>
             <Flex gap={'3'}>
                 <TextField.Root type="date" placeholder="От" value={fromDate} onChange={e => setFromDate(e.target.value)}>

                 </TextField.Root>
                 <TextField.Root type="date" placeholder="До" value={toDate} onChange={e => setToDate(e.target.value)}>

                 </TextField.Root>
             </Flex>
             {isLoading && <Spinner />}
            </Container>
                               <Chart
                          className="z-10"
        options={{
          data: dataToChartsStructure,
          primaryAxis,
          secondaryAxes
        }}
      />
         
        </Container>
    )
}